import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Force update favicon to bypass browser cache - run before React renders
(function() {
  const head = document.head || document.getElementsByTagName('head')[0];
  
  // Remove ALL existing favicon links
  const existingLinks = document.querySelectorAll("link[rel*='icon'], link[rel='shortcut icon']");
  existingLinks.forEach(link => {
    if (link.parentNode) {
      link.parentNode.removeChild(link);
    }
  });
  
  // Create new favicon links
  const faviconPNG = document.createElement('link');
  faviconPNG.rel = 'icon';
  faviconPNG.type = 'image/png';
  faviconPNG.href = '/favicon.png?t=' + Date.now();
  head.appendChild(faviconPNG);
  
  const faviconICO = document.createElement('link');
  faviconICO.rel = 'shortcut icon';
  faviconICO.type = 'image/x-icon';
  faviconICO.href = '/favicon.ico?t=' + Date.now();
  head.appendChild(faviconICO);
  
  // Also try to update the favicon programmatically
  const img = document.createElement('img');
  img.src = '/favicon.png?t=' + Date.now();
  img.onload = function() {
    const canvas = document.createElement('canvas');
    canvas.width = this.width;
    canvas.height = this.height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(this, 0, 0);
    canvas.toBlob(function(blob) {
      const url = URL.createObjectURL(blob);
      const link = document.querySelector("link[rel*='icon']");
      if (link) {
        link.href = url;
      }
    });
  };
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
